export class Order {
    constructor(order){
        const props = {...orderModel, ...(JSON.parse(JSON.stringify(order)))}
        Object.entries(props).forEach(([key, value]) => {
            this[key] = value
        })
    }
}

export const orderModel = {
    description: '',
    customerId: '',
    customerName: '',
    status: 'pending',
    subtractFromStock: true,
    items: [],
    price: 0,
    createdAt: new Date,
    updatedAt: new Date
}